
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AppLayout } from "../components/AppLayout";

export default function NotFound() {
  return (
    <AppLayout requireAuth={false}>
      <div className="flex flex-col items-center justify-center min-h-[70vh] text-center">
        <h1 className="text-6xl font-bold text-househeld-700">404</h1>
        <h2 className="text-2xl font-semibold mt-4 mb-2">Page Not Found</h2>
        <p className="text-muted-foreground mb-6 max-w-md">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/">
          <Button>Return to Dashboard</Button>
        </Link>
      </div>
    </AppLayout>
  );
}
